export default "__VITE_ASSET__Bq$u7VoI__"